import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className={`text-xl font-heading font-bold transition-colors duration-300 ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}>
                果冻传媒
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive(link.path)
                      ? 'bg-primary-500 text-background-50'
                      : scrolled
                        ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                        : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <div className={`hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full transition-colors duration-200 ${
                scrolled ? 'bg-background-100' : 'bg-background-50/15'
              }`}>
                <i className={`ri-search-line text-sm ${
                  scrolled ? 'text-foreground-500' : 'text-background-50/70'
                }`}></i>
                <input
                  type="text"
                  placeholder="搜索视频..."
                  className={`bg-transparent border-none outline-none text-sm w-32 placeholder:text-sm ${
                    scrolled
                      ? 'text-foreground-800 placeholder:text-foreground-400'
                      : 'text-background-50 placeholder:text-background-50/50'
                  }`}
                />
              </div>

              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-background-50 hover:bg-background-50/15'
                }`}
                aria-label="菜单"
              >
                <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setMobileOpen(false)}
          ></div>
          <div className="absolute top-16 left-0 right-0 bg-background-50 shadow-lg rounded-b-2xl p-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all cursor-pointer ${
                    isActive(link.path)
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${link.icon} text-base`}></i>
                  {link.name}
                </Link>
              ))}
              <div className="flex items-center gap-2 px-4 py-3 mt-2 bg-background-100 rounded-xl">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索视频..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-800 placeholder:text-foreground-400 w-full"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}